var _a, _b, _c;
import { detect } from 'detect-browser';
const browser = detect();
const browserName = (_a = browser === null || browser === void 0 ? void 0 : browser.name) !== null && _a !== void 0 ? _a : 'unknown';
const browserVersion = (_b = browser === null || browser === void 0 ? void 0 : browser.version) !== null && _b !== void 0 ? _b : 'unknown';
const operatingSystem = (_c = browser === null || browser === void 0 ? void 0 : browser.os) !== null && _c !== void 0 ? _c : 'unknown';
const browserDetails = {
    browser: browserName,
    browserVersion,
    operatingSystem,
};
Object.freeze(browserDetails);
export default browserDetails;
